module.exports = __webpack_public_path__ + "static/Huskar_icon-6a2f498ca4e991ffa844eaff7a6de2f7.webp";